<template>
  <div class="clinical">
    <div class="container">
      <div class="title"></div>
      <div class="sub-title">关于阿托品</div>
      <div class="content">
        阿托品是一种M胆碱受体抑制剂，阿托品滴眼液具有使瞳孔括约肌和睫状肌松弛，
        出现扩瞳、眼内血压升高和调节麻痹的作用，临床上主要用于散瞳验光。
      </div>
      <div class="item">
        <div class="sub-title">ATOM1试验</div>
        <div class="content">
          2005年新加坡眼科研究所（SERI）在美国眼科学会Ophthalmology杂志发表一项关于阿托品
          滴眼液对控制近视发展速率的ATOM1临床试验。ATOM1临床入组400名轻中度近视（100度至600度，
          -1D至-6D）6-12岁儿童，平均分配至1%阿托品滴眼液组和安慰剂对照组，每晚给药一滴持续
          两年，评估阿托品对于控制近视进展和眼轴增长的疗效和安全性。该试验结果表明：<span
            class="highlight"
          >
            1%阿托品滴眼液减少近视进展的程度为77%，延缓眼轴增长的程度为100%，但会导致瞳孔放大
            、畏光、近视模糊、紫外线暴露增加等副作用
          </span>
        </div>
        <div class="item-image">
          <img src="../../../../assets/moblie/images/statis1.png" />
        </div>
        <div class="item-image">
          <img src="../../../../assets/moblie/images/statis2.png" />
        </div>
      </div>
      <div class="item item2">
        <div class="sub-title">ATOM2试验</div>
        <div class="content">
          由于ATOM1临床仅进行了两年：长期的安全性和有效性存疑。因此，SERI随后启用了ATOM2
          临床研究，入组400名近视（200度以上，大于-2D）6-12岁儿童，以2：2:1分配至0.5%、0.1%
          和0.01%的阿托品滴眼液组，每晚给药一滴持续两年，以评估不同浓度阿托品滴眼液的疗效和
          安全性。经过5年的治疗后，<span class="highlight">
            0.01%阿托品滴眼液组近视进展和眼轴增长分别为-1.38±0.98D和0.75±0.48mm，远小于0.1%
            阿托品滴眼液组（-1.83±1.16D;0.85±0.53mm）和0.5%阿托品滴眼液组(-1.98±1.10D；0.87±0.49mm)
            ，且延缓近视进展达到统计显著
          </span>
        </div>
        <div class="item-image">
          <img src="../../../../assets/moblie/images/statis3.png" />
        </div>
        <div class="item-image">
          <img src="../../../../assets/moblie/images/statis4.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ClinicalTrial",
  components: {},
  props: {},
  computed: {},
  data: function() {
    return {};
  },
  created() {},
  mounted: function() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.clinical {
  background-color: rgb(72, 173, 241);
  padding: 15px 20px;
  overflow: auto;
  .container {
    height: 100%;
    background-image: url("../../../../assets/moblie/images/clinicbg.png");
    background-size: 100%;
    padding: 15px 15px;
    .title {
      width: 80%;
      height: 1.5rem;
      background-image: url("../../../../assets/moblie/images/clinictitle.png");
      background-size: 100% 100%;
      margin: 0 auto;
    }
    .sub-title {
      background-color: rgb(46, 119, 196);
      color: #fff;
      font-size: 0.4rem;
      font-weight: 700;
      padding: 5px 20px;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      width: 3.2rem;
      box-sizing: border-box;
      position: relative;
      left: -20px;
      margin-top: 0.2rem;
    }
    .content {
      margin-top: 0.2rem;
      font-size: 0.3rem;
      line-height: 0.44rem;
      margin-bottom: 0.2rem;
    }
    .item {
      margin-top: 1.3rem;
      &-image {
        width: 4.2rem;
        height: 3.4rem;
        margin: 0 auto;
        margin-top: 0.2rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .item2 {
      margin-top: 2.3rem;
    }
    .highlight {
      color: rgb(51, 116, 188);
      font-weight: 600;
    }
  }
}
</style>
